export function sendQuote(quote) {
  return {
    type: 'SEND_QUOTE',
    payload: quote,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            mock: false,
            base: '/quotes/get',
          },
        },
        commit: {
          type: 'SEND_QUOTE_COMMIT',
        },
        rollback: {
          type: 'SEND_QUOTE_ROLLBACK',
        },
      },
    },
  }
}
